import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RecordShrinkEventMutationVariables = Types.Exact<{
  input: Types.RecordShrinkEventDataInput;
}>;


export type RecordShrinkEventMutation = { __typename?: 'Mutation', recordShrinkEvent: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveShrinkEventMutationVariables = Types.Exact<{
  input: Types.RemoveShrinkEventDataInput;
}>;


export type RemoveShrinkEventMutation = { __typename?: 'Mutation', removeShrinkEvent: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type OverrideProductionJobWeekReadyMutationVariables = Types.Exact<{
  input: Types.OverrideProductionJobWeekReadyDataInput;
}>;


export type OverrideProductionJobWeekReadyMutation = { __typename?: 'Mutation', overrideProductionJobWeekReady: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type OverrideProductionJobWeekStartMutationVariables = Types.Exact<{
  input: Types.OverrideProductionJobWeekStartDataInput;
}>;


export type OverrideProductionJobWeekStartMutation = { __typename?: 'Mutation', overrideProductionJobWeekStart: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BatchOverrideProductionJobWeeksMutationVariables = Types.Exact<{
  input: Types.BatchOverrideProductionJobWeeksInput;
}>;


export type BatchOverrideProductionJobWeeksMutation = { __typename?: 'Mutation', batchOverrideProductionJobWeeks: { __typename?: 'BatchOverrideProductionJobWeeksPayload', results: Array<{ __typename?: 'BatchOverrideProductionJobWeeksResult', productionLotId: string, productionJobId: string, ok: boolean, weekReadyDate?: Types.TDateISO | null, weekStartDate?: Types.TDateISO | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }>, cascadedJobs?: Array<{ __typename?: 'BatchOverrideProductionJobWeeksCascadedJob', productionLotId: string, productionJobId: string, previousWeekReadyDate?: Types.TDateISO | null, newWeekReadyDate?: Types.TDateISO | null, previousWeekStartDate?: Types.TDateISO | null, newWeekStartDate?: Types.TDateISO | null }> | null, productionLots?: Array<{ __typename?: 'ProductionLotStateData', productionLotId: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number }> }> }> } }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type OverrideProductionJobYieldMutationVariables = Types.Exact<{
  input: Types.OverrideProductionJobYieldDataInput;
}>;


export type OverrideProductionJobYieldMutation = { __typename?: 'Mutation', overrideProductionJobYield: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type OverrideProductionLotQuantityMutationVariables = Types.Exact<{
  input: Types.OverrideProductionLotQuantityDataInput;
}>;


export type OverrideProductionLotQuantityMutation = { __typename?: 'Mutation', overrideProductionLotQuantity: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type OverrideProductionJobQuantityMutationVariables = Types.Exact<{
  input: Types.OverrideProductionJobQuantityDataInput;
}>;


export type OverrideProductionJobQuantityMutation = { __typename?: 'Mutation', overrideProductionJobQuantity: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateProductionLotMutationVariables = Types.Exact<{
  input: Types.ActivateProductionLotInput;
}>;


export type ActivateProductionLotMutation = { __typename?: 'Mutation', activateProductionLot: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeactivateProductionLotMutationVariables = Types.Exact<{
  input: Types.DeactivateProductionLotInput;
}>;


export type DeactivateProductionLotMutation = { __typename?: 'Mutation', deactivateProductionLot: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BatchDeactivateProductionLotsMutationVariables = Types.Exact<{
  input: Types.BatchDeactivateProductionLotsInput;
}>;


export type BatchDeactivateProductionLotsMutation = { __typename?: 'Mutation', batchDeactivateProductionLots: { __typename?: 'BatchDeactivateProductionLotsPayload', results: Array<{ __typename?: 'BatchDeactivateProductionLotResult', productionLotId: string, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BatchCreateDraftProductionLotsMutationVariables = Types.Exact<{
  input: Types.BatchCreateDraftProductionLotsInput;
}>;


export type BatchCreateDraftProductionLotsMutation = { __typename?: 'Mutation', batchCreateDraftProductionLots: { __typename?: 'BatchCreateDraftProductionLotsPayload', results: Array<{ __typename?: 'BatchCreateDraftProductionLotResult', productionLotId: string, skipped: boolean, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type OverrideProductionLotCustomerMutationVariables = Types.Exact<{
  input: Types.OverrideProductionLotCustomerDataInput;
}>;


export type OverrideProductionLotCustomerMutation = { __typename?: 'Mutation', overrideProductionLotCustomer: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearProductionLotCustomerMutationVariables = Types.Exact<{
  input: Types.ClearProductionLotCustomerInput;
}>;


export type ClearProductionLotCustomerMutation = { __typename?: 'Mutation', clearProductionLotCustomer: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type OverrideProductionLotCustomerGroupMutationVariables = Types.Exact<{
  input: Types.OverrideProductionLotCustomerGroupInput;
}>;


export type OverrideProductionLotCustomerGroupMutation = { __typename?: 'Mutation', overrideProductionLotCustomerGroup: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearProductionLotCustomerGroupMutationVariables = Types.Exact<{
  input: Types.ClearProductionLotCustomerGroupInput;
}>;


export type ClearProductionLotCustomerGroupMutation = { __typename?: 'Mutation', clearProductionLotCustomerGroup: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetProductionLotProductionItemMutationVariables = Types.Exact<{
  input: Types.SetProductionLotProductionItemInput;
}>;


export type SetProductionLotProductionItemMutation = { __typename?: 'Mutation', setProductionLotProductionItem: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type OverrideProductionJobLocationMutationVariables = Types.Exact<{
  input: Types.OverrideProductionJobLocationDataInput;
}>;


export type OverrideProductionJobLocationMutation = { __typename?: 'Mutation', overrideProductionJobLocation: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProductionJobLocationMutationVariables = Types.Exact<{
  input: Types.UpdateProductionJobLocationInput;
}>;


export type UpdateProductionJobLocationMutation = { __typename?: 'Mutation', updateProductionJobLocation: { __typename?: 'UpdateProductionJobLocationPayload', productionLots?: Array<{ __typename?: 'ProductionLotStateData', productionLotId: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number }> }> }> } }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PlanProductionJobMovesMutationVariables = Types.Exact<{
  input: Types.PlanProductionJobMovesInput;
}>;


export type PlanProductionJobMovesMutation = { __typename?: 'Mutation', planProductionJobMoves: { __typename?: 'PlanProductionJobMovesPayload', taskAssignmentIds?: Array<string> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreateProductionLotMutationVariables = Types.Exact<{
  input: Types.CreateProductionLotInput;
}>;


export type CreateProductionLotMutation = { __typename?: 'Mutation', createProductionLot: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SubmitDraftProductionLotMutationVariables = Types.Exact<{
  input: Types.CreateProductionLotInput;
}>;


export type SubmitDraftProductionLotMutation = { __typename?: 'Mutation', submitDraftProductionLot: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ApproveProductionLotMutationVariables = Types.Exact<{
  input: Types.ApproveProductionLotInput;
}>;


export type ApproveProductionLotMutation = { __typename?: 'Mutation', approveProductionLot: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteProductionLotMutationVariables = Types.Exact<{
  input: Types.DeleteProductionLotInput;
}>;


export type DeleteProductionLotMutation = { __typename?: 'Mutation', deleteProductionLot: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type MergeProductionPlanMutationVariables = Types.Exact<{
  input: Types.MergeProductionPlanInput;
}>;


export type MergeProductionPlanMutation = { __typename?: 'Mutation', mergeProductionPlan: { __typename?: 'ProductionPlanPayload', productionPlan?: { __typename?: 'ProductionPlanStateData', productionPlanId: string, name: string, status: Types.ProductionPlanStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type OverrideProducedQuantityMutationVariables = Types.Exact<{
  input: Types.OverrideProducedQuantityDataInput;
}>;


export type OverrideProducedQuantityMutation = { __typename?: 'Mutation', overrideProducedQuantity: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetJobGrowWeeksOverrideMutationVariables = Types.Exact<{
  input: Types.SetJobGrowWeeksOverrideDataInput;
}>;


export type SetJobGrowWeeksOverrideMutation = { __typename?: 'Mutation', setJobGrowWeeksOverride: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetJobPlantsPerPotOverrideMutationVariables = Types.Exact<{
  input: Types.SetJobPlantsPerPotOverrideDataInput;
}>;


export type SetJobPlantsPerPotOverrideMutation = { __typename?: 'Mutation', setJobPlantsPerPotOverride: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetJobPlannedHoursOverrideMutationVariables = Types.Exact<{
  input: Types.SetJobPlannedHoursOverrideDataInput;
}>;


export type SetJobPlannedHoursOverrideMutation = { __typename?: 'Mutation', setJobPlannedHoursOverride: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearJobPlannedHoursOverrideMutationVariables = Types.Exact<{
  input: Types.ClearJobPlannedHoursOverrideDataInput;
}>;


export type ClearJobPlannedHoursOverrideMutation = { __typename?: 'Mutation', clearJobPlannedHoursOverride: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProductionLotPlanMutationVariables = Types.Exact<{
  input: Types.UpdateProductionLotPlanInput;
}>;


export type UpdateProductionLotPlanMutation = { __typename?: 'Mutation', updateProductionLotPlan: { __typename?: 'UpdateProductionLotPlanPayload', productionLots?: Array<{ __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SplitProductionLotMutationVariables = Types.Exact<{
  input: Types.SplitProductionLotDataInput;
}>;


export type SplitProductionLotMutation = { __typename?: 'Mutation', splitProductionLot: { __typename?: 'SplitProductionLotPayload', productionLots?: Array<{ __typename?: 'ProductionLotStateData', productionLotId: string, productionPlanId: string, lotNumber: number, quantity: number, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number, weekReadyDate: Types.TDateISO } }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SubmitProducedQuantityForReviewMutationVariables = Types.Exact<{
  input: Types.SubmitProducedQuantityForReviewInput;
}>;


export type SubmitProducedQuantityForReviewMutation = { __typename?: 'Mutation', submitProducedQuantityForReview: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ConfirmProducedQuantityEntryMutationVariables = Types.Exact<{
  input: Types.ConfirmProducedQuantityEntryInput;
}>;


export type ConfirmProducedQuantityEntryMutation = { __typename?: 'Mutation', confirmProducedQuantityEntry: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RejectProducedQuantityEntryMutationVariables = Types.Exact<{
  input: Types.RejectProducedQuantityEntryInput;
}>;


export type RejectProducedQuantityEntryMutation = { __typename?: 'Mutation', rejectProducedQuantityEntry: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', tenantId: string, productionLotId: string, productionPlanId: string, productionItemId?: string | null, customerId?: string | null, customerGroupId?: string | null, poNumber?: string | null, quantity: number, status: Types.ProductionLotStatus, isAd: boolean, isTrial: boolean, isPreFinished: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, childJobs: Array<{ __typename?: 'ProductionJobData', productionJobId: string, productionCatalogId: string, productionCategoryId: string, productionRecipeId: string, locationId?: string | null, quantity: number, yield: number, weekReadyDate: Types.TDateISO, weekStartDate: Types.TDateISO, notes?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const RecordShrinkEventDocument = new TypedDocumentString(`
    mutation RecordShrinkEvent($input: RecordShrinkEventDataInput!) {
  recordShrinkEvent(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const RemoveShrinkEventDocument = new TypedDocumentString(`
    mutation RemoveShrinkEvent($input: RemoveShrinkEventDataInput!) {
  removeShrinkEvent(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const OverrideProductionJobWeekReadyDocument = new TypedDocumentString(`
    mutation OverrideProductionJobWeekReady($input: OverrideProductionJobWeekReadyDataInput!) {
  overrideProductionJobWeekReady(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const OverrideProductionJobWeekStartDocument = new TypedDocumentString(`
    mutation OverrideProductionJobWeekStart($input: OverrideProductionJobWeekStartDataInput!) {
  overrideProductionJobWeekStart(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const BatchOverrideProductionJobWeeksDocument = new TypedDocumentString(`
    mutation BatchOverrideProductionJobWeeks($input: BatchOverrideProductionJobWeeksInput!) {
  batchOverrideProductionJobWeeks(input: $input) {
    results {
      productionLotId
      productionJobId
      ok
      weekReadyDate
      weekStartDate
      errors {
        code
        message
      }
    }
    cascadedJobs {
      productionLotId
      productionJobId
      previousWeekReadyDate
      newWeekReadyDate
      previousWeekStartDate
      newWeekStartDate
    }
    productionLots {
      ...ProductionLotJobNumbers
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotJobNumbers on ProductionLotStateData {
  productionLotId
  finishJob {
    ...ProductionJobNumber
    childJobs {
      ...ProductionJobNumber
      childJobs {
        ...ProductionJobNumber
        childJobs {
          ...ProductionJobNumber
        }
      }
    }
  }
}
fragment ProductionJobNumber on ProductionJobData {
  productionJobId
  jobNumber
}`);
export const OverrideProductionJobYieldDocument = new TypedDocumentString(`
    mutation OverrideProductionJobYield($input: OverrideProductionJobYieldDataInput!) {
  overrideProductionJobYield(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const OverrideProductionLotQuantityDocument = new TypedDocumentString(`
    mutation OverrideProductionLotQuantity($input: OverrideProductionLotQuantityDataInput!) {
  overrideProductionLotQuantity(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const OverrideProductionJobQuantityDocument = new TypedDocumentString(`
    mutation OverrideProductionJobQuantity($input: OverrideProductionJobQuantityDataInput!) {
  overrideProductionJobQuantity(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const ActivateProductionLotDocument = new TypedDocumentString(`
    mutation ActivateProductionLot($input: ActivateProductionLotInput!) {
  activateProductionLot(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const DeactivateProductionLotDocument = new TypedDocumentString(`
    mutation DeactivateProductionLot($input: DeactivateProductionLotInput!) {
  deactivateProductionLot(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const BatchDeactivateProductionLotsDocument = new TypedDocumentString(`
    mutation BatchDeactivateProductionLots($input: BatchDeactivateProductionLotsInput!) {
  batchDeactivateProductionLots(input: $input) {
    results {
      productionLotId
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const BatchCreateDraftProductionLotsDocument = new TypedDocumentString(`
    mutation BatchCreateDraftProductionLots($input: BatchCreateDraftProductionLotsInput!) {
  batchCreateDraftProductionLots(input: $input) {
    results {
      productionLotId
      skipped
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const OverrideProductionLotCustomerDocument = new TypedDocumentString(`
    mutation OverrideProductionLotCustomer($input: OverrideProductionLotCustomerDataInput!) {
  overrideProductionLotCustomer(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const ClearProductionLotCustomerDocument = new TypedDocumentString(`
    mutation ClearProductionLotCustomer($input: ClearProductionLotCustomerInput!) {
  clearProductionLotCustomer(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const OverrideProductionLotCustomerGroupDocument = new TypedDocumentString(`
    mutation OverrideProductionLotCustomerGroup($input: OverrideProductionLotCustomerGroupInput!) {
  overrideProductionLotCustomerGroup(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const ClearProductionLotCustomerGroupDocument = new TypedDocumentString(`
    mutation ClearProductionLotCustomerGroup($input: ClearProductionLotCustomerGroupInput!) {
  clearProductionLotCustomerGroup(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const SetProductionLotProductionItemDocument = new TypedDocumentString(`
    mutation SetProductionLotProductionItem($input: SetProductionLotProductionItemInput!) {
  setProductionLotProductionItem(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const OverrideProductionJobLocationDocument = new TypedDocumentString(`
    mutation OverrideProductionJobLocation($input: OverrideProductionJobLocationDataInput!) {
  overrideProductionJobLocation(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const UpdateProductionJobLocationDocument = new TypedDocumentString(`
    mutation UpdateProductionJobLocation($input: UpdateProductionJobLocationInput!) {
  updateProductionJobLocation(input: $input) {
    productionLots {
      ...ProductionLotJobNumbers
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotJobNumbers on ProductionLotStateData {
  productionLotId
  finishJob {
    ...ProductionJobNumber
    childJobs {
      ...ProductionJobNumber
      childJobs {
        ...ProductionJobNumber
        childJobs {
          ...ProductionJobNumber
        }
      }
    }
  }
}
fragment ProductionJobNumber on ProductionJobData {
  productionJobId
  jobNumber
}`);
export const PlanProductionJobMovesDocument = new TypedDocumentString(`
    mutation PlanProductionJobMoves($input: PlanProductionJobMovesInput!) {
  planProductionJobMoves(input: $input) {
    taskAssignmentIds
    errors {
      code
      message
    }
  }
}
    `);
export const CreateProductionLotDocument = new TypedDocumentString(`
    mutation CreateProductionLot($input: CreateProductionLotInput!) {
  createProductionLot(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const SubmitDraftProductionLotDocument = new TypedDocumentString(`
    mutation SubmitDraftProductionLot($input: CreateProductionLotInput!) {
  submitDraftProductionLot(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const ApproveProductionLotDocument = new TypedDocumentString(`
    mutation ApproveProductionLot($input: ApproveProductionLotInput!) {
  approveProductionLot(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const DeleteProductionLotDocument = new TypedDocumentString(`
    mutation DeleteProductionLot($input: DeleteProductionLotInput!) {
  deleteProductionLot(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const MergeProductionPlanDocument = new TypedDocumentString(`
    mutation MergeProductionPlan($input: MergeProductionPlanInput!) {
  mergeProductionPlan(input: $input) {
    productionPlan {
      productionPlanId
      name
      status
    }
    errors {
      code
      message
    }
  }
}
    `);
export const OverrideProducedQuantityDocument = new TypedDocumentString(`
    mutation OverrideProducedQuantity($input: OverrideProducedQuantityDataInput!) {
  overrideProducedQuantity(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const SetJobGrowWeeksOverrideDocument = new TypedDocumentString(`
    mutation SetJobGrowWeeksOverride($input: SetJobGrowWeeksOverrideDataInput!) {
  setJobGrowWeeksOverride(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const SetJobPlantsPerPotOverrideDocument = new TypedDocumentString(`
    mutation SetJobPlantsPerPotOverride($input: SetJobPlantsPerPotOverrideDataInput!) {
  setJobPlantsPerPotOverride(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const SetJobPlannedHoursOverrideDocument = new TypedDocumentString(`
    mutation SetJobPlannedHoursOverride($input: SetJobPlannedHoursOverrideDataInput!) {
  setJobPlannedHoursOverride(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const ClearJobPlannedHoursOverrideDocument = new TypedDocumentString(`
    mutation ClearJobPlannedHoursOverride($input: ClearJobPlannedHoursOverrideDataInput!) {
  clearJobPlannedHoursOverride(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const UpdateProductionLotPlanDocument = new TypedDocumentString(`
    mutation UpdateProductionLotPlan($input: UpdateProductionLotPlanInput!) {
  updateProductionLotPlan(input: $input) {
    productionLots {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const SplitProductionLotDocument = new TypedDocumentString(`
    mutation SplitProductionLot($input: SplitProductionLotDataInput!) {
  splitProductionLot(input: $input) {
    productionLots {
      ...ProductionLotCreatedFragment
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotCreatedFragment on ProductionLotStateData {
  productionLotId
  productionPlanId
  lotNumber
  quantity
  finishJob {
    productionJobId
    jobNumber
    weekReadyDate
  }
}`);
export const SubmitProducedQuantityForReviewDocument = new TypedDocumentString(`
    mutation SubmitProducedQuantityForReview($input: SubmitProducedQuantityForReviewInput!) {
  submitProducedQuantityForReview(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const ConfirmProducedQuantityEntryDocument = new TypedDocumentString(`
    mutation ConfirmProducedQuantityEntry($input: ConfirmProducedQuantityEntryInput!) {
  confirmProducedQuantityEntry(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
export const RejectProducedQuantityEntryDocument = new TypedDocumentString(`
    mutation RejectProducedQuantityEntry($input: RejectProducedQuantityEntryInput!) {
  rejectProducedQuantityEntry(input: $input) {
    productionLot {
      ...ProductionLotDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotDetails on ProductionLotStateData {
  tenantId
  productionLotId
  productionPlanId
  productionItemId
  customerId
  customerGroupId
  poNumber
  quantity
  status
  isAd
  isTrial
  isPreFinished
  createdAt
  createdBy
  updatedAt
  updatedBy
  finishJob {
    ...ProductionJobDetails
  }
}
fragment ProductionJobDetails on ProductionJobData {
  productionJobId
  productionCatalogId
  productionCategoryId
  productionRecipeId
  locationId
  quantity
  yield
  weekReadyDate
  weekStartDate
  notes
  createdAt
  createdBy
  updatedAt
  updatedBy
  childJobs {
    productionJobId
    productionCatalogId
    productionCategoryId
    productionRecipeId
    locationId
    quantity
    yield
    weekReadyDate
    weekStartDate
    notes
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    RecordShrinkEvent: build.mutation<RecordShrinkEventMutation, RecordShrinkEventMutationVariables>({
      query: (variables) => ({ document: RecordShrinkEventDocument, variables })
    }),
    RemoveShrinkEvent: build.mutation<RemoveShrinkEventMutation, RemoveShrinkEventMutationVariables>({
      query: (variables) => ({ document: RemoveShrinkEventDocument, variables })
    }),
    OverrideProductionJobWeekReady: build.mutation<OverrideProductionJobWeekReadyMutation, OverrideProductionJobWeekReadyMutationVariables>({
      query: (variables) => ({ document: OverrideProductionJobWeekReadyDocument, variables })
    }),
    OverrideProductionJobWeekStart: build.mutation<OverrideProductionJobWeekStartMutation, OverrideProductionJobWeekStartMutationVariables>({
      query: (variables) => ({ document: OverrideProductionJobWeekStartDocument, variables })
    }),
    BatchOverrideProductionJobWeeks: build.mutation<BatchOverrideProductionJobWeeksMutation, BatchOverrideProductionJobWeeksMutationVariables>({
      query: (variables) => ({ document: BatchOverrideProductionJobWeeksDocument, variables })
    }),
    OverrideProductionJobYield: build.mutation<OverrideProductionJobYieldMutation, OverrideProductionJobYieldMutationVariables>({
      query: (variables) => ({ document: OverrideProductionJobYieldDocument, variables })
    }),
    OverrideProductionLotQuantity: build.mutation<OverrideProductionLotQuantityMutation, OverrideProductionLotQuantityMutationVariables>({
      query: (variables) => ({ document: OverrideProductionLotQuantityDocument, variables })
    }),
    OverrideProductionJobQuantity: build.mutation<OverrideProductionJobQuantityMutation, OverrideProductionJobQuantityMutationVariables>({
      query: (variables) => ({ document: OverrideProductionJobQuantityDocument, variables })
    }),
    ActivateProductionLot: build.mutation<ActivateProductionLotMutation, ActivateProductionLotMutationVariables>({
      query: (variables) => ({ document: ActivateProductionLotDocument, variables })
    }),
    DeactivateProductionLot: build.mutation<DeactivateProductionLotMutation, DeactivateProductionLotMutationVariables>({
      query: (variables) => ({ document: DeactivateProductionLotDocument, variables })
    }),
    BatchDeactivateProductionLots: build.mutation<BatchDeactivateProductionLotsMutation, BatchDeactivateProductionLotsMutationVariables>({
      query: (variables) => ({ document: BatchDeactivateProductionLotsDocument, variables })
    }),
    BatchCreateDraftProductionLots: build.mutation<BatchCreateDraftProductionLotsMutation, BatchCreateDraftProductionLotsMutationVariables>({
      query: (variables) => ({ document: BatchCreateDraftProductionLotsDocument, variables })
    }),
    OverrideProductionLotCustomer: build.mutation<OverrideProductionLotCustomerMutation, OverrideProductionLotCustomerMutationVariables>({
      query: (variables) => ({ document: OverrideProductionLotCustomerDocument, variables })
    }),
    ClearProductionLotCustomer: build.mutation<ClearProductionLotCustomerMutation, ClearProductionLotCustomerMutationVariables>({
      query: (variables) => ({ document: ClearProductionLotCustomerDocument, variables })
    }),
    OverrideProductionLotCustomerGroup: build.mutation<OverrideProductionLotCustomerGroupMutation, OverrideProductionLotCustomerGroupMutationVariables>({
      query: (variables) => ({ document: OverrideProductionLotCustomerGroupDocument, variables })
    }),
    ClearProductionLotCustomerGroup: build.mutation<ClearProductionLotCustomerGroupMutation, ClearProductionLotCustomerGroupMutationVariables>({
      query: (variables) => ({ document: ClearProductionLotCustomerGroupDocument, variables })
    }),
    SetProductionLotProductionItem: build.mutation<SetProductionLotProductionItemMutation, SetProductionLotProductionItemMutationVariables>({
      query: (variables) => ({ document: SetProductionLotProductionItemDocument, variables })
    }),
    OverrideProductionJobLocation: build.mutation<OverrideProductionJobLocationMutation, OverrideProductionJobLocationMutationVariables>({
      query: (variables) => ({ document: OverrideProductionJobLocationDocument, variables })
    }),
    UpdateProductionJobLocation: build.mutation<UpdateProductionJobLocationMutation, UpdateProductionJobLocationMutationVariables>({
      query: (variables) => ({ document: UpdateProductionJobLocationDocument, variables })
    }),
    PlanProductionJobMoves: build.mutation<PlanProductionJobMovesMutation, PlanProductionJobMovesMutationVariables>({
      query: (variables) => ({ document: PlanProductionJobMovesDocument, variables })
    }),
    CreateProductionLot: build.mutation<CreateProductionLotMutation, CreateProductionLotMutationVariables>({
      query: (variables) => ({ document: CreateProductionLotDocument, variables })
    }),
    SubmitDraftProductionLot: build.mutation<SubmitDraftProductionLotMutation, SubmitDraftProductionLotMutationVariables>({
      query: (variables) => ({ document: SubmitDraftProductionLotDocument, variables })
    }),
    ApproveProductionLot: build.mutation<ApproveProductionLotMutation, ApproveProductionLotMutationVariables>({
      query: (variables) => ({ document: ApproveProductionLotDocument, variables })
    }),
    DeleteProductionLot: build.mutation<DeleteProductionLotMutation, DeleteProductionLotMutationVariables>({
      query: (variables) => ({ document: DeleteProductionLotDocument, variables })
    }),
    MergeProductionPlan: build.mutation<MergeProductionPlanMutation, MergeProductionPlanMutationVariables>({
      query: (variables) => ({ document: MergeProductionPlanDocument, variables })
    }),
    OverrideProducedQuantity: build.mutation<OverrideProducedQuantityMutation, OverrideProducedQuantityMutationVariables>({
      query: (variables) => ({ document: OverrideProducedQuantityDocument, variables })
    }),
    SetJobGrowWeeksOverride: build.mutation<SetJobGrowWeeksOverrideMutation, SetJobGrowWeeksOverrideMutationVariables>({
      query: (variables) => ({ document: SetJobGrowWeeksOverrideDocument, variables })
    }),
    SetJobPlantsPerPotOverride: build.mutation<SetJobPlantsPerPotOverrideMutation, SetJobPlantsPerPotOverrideMutationVariables>({
      query: (variables) => ({ document: SetJobPlantsPerPotOverrideDocument, variables })
    }),
    SetJobPlannedHoursOverride: build.mutation<SetJobPlannedHoursOverrideMutation, SetJobPlannedHoursOverrideMutationVariables>({
      query: (variables) => ({ document: SetJobPlannedHoursOverrideDocument, variables })
    }),
    ClearJobPlannedHoursOverride: build.mutation<ClearJobPlannedHoursOverrideMutation, ClearJobPlannedHoursOverrideMutationVariables>({
      query: (variables) => ({ document: ClearJobPlannedHoursOverrideDocument, variables })
    }),
    UpdateProductionLotPlan: build.mutation<UpdateProductionLotPlanMutation, UpdateProductionLotPlanMutationVariables>({
      query: (variables) => ({ document: UpdateProductionLotPlanDocument, variables })
    }),
    SplitProductionLot: build.mutation<SplitProductionLotMutation, SplitProductionLotMutationVariables>({
      query: (variables) => ({ document: SplitProductionLotDocument, variables })
    }),
    SubmitProducedQuantityForReview: build.mutation<SubmitProducedQuantityForReviewMutation, SubmitProducedQuantityForReviewMutationVariables>({
      query: (variables) => ({ document: SubmitProducedQuantityForReviewDocument, variables })
    }),
    ConfirmProducedQuantityEntry: build.mutation<ConfirmProducedQuantityEntryMutation, ConfirmProducedQuantityEntryMutationVariables>({
      query: (variables) => ({ document: ConfirmProducedQuantityEntryDocument, variables })
    }),
    RejectProducedQuantityEntry: build.mutation<RejectProducedQuantityEntryMutation, RejectProducedQuantityEntryMutationVariables>({
      query: (variables) => ({ document: RejectProducedQuantityEntryDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useRecordShrinkEventMutation, useRemoveShrinkEventMutation, useOverrideProductionJobWeekReadyMutation, useOverrideProductionJobWeekStartMutation, useBatchOverrideProductionJobWeeksMutation, useOverrideProductionJobYieldMutation, useOverrideProductionLotQuantityMutation, useOverrideProductionJobQuantityMutation, useActivateProductionLotMutation, useDeactivateProductionLotMutation, useBatchDeactivateProductionLotsMutation, useBatchCreateDraftProductionLotsMutation, useOverrideProductionLotCustomerMutation, useClearProductionLotCustomerMutation, useOverrideProductionLotCustomerGroupMutation, useClearProductionLotCustomerGroupMutation, useSetProductionLotProductionItemMutation, useOverrideProductionJobLocationMutation, useUpdateProductionJobLocationMutation, usePlanProductionJobMovesMutation, useCreateProductionLotMutation, useSubmitDraftProductionLotMutation, useApproveProductionLotMutation, useDeleteProductionLotMutation, useMergeProductionPlanMutation, useOverrideProducedQuantityMutation, useSetJobGrowWeeksOverrideMutation, useSetJobPlantsPerPotOverrideMutation, useSetJobPlannedHoursOverrideMutation, useClearJobPlannedHoursOverrideMutation, useUpdateProductionLotPlanMutation, useSplitProductionLotMutation, useSubmitProducedQuantityForReviewMutation, useConfirmProducedQuantityEntryMutation, useRejectProducedQuantityEntryMutation } = injectedRtkApi;
